module.exports = __webpack_public_path__ + "assets/img/bg_desktop.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg_desktop.svg
// module id = 693
// module chunks = 0